module.exports = __webpack_public_path__ + "img/content-while.1b8d56b3.svg";